export default {
    REASON_BEING_LATE: {
        form2: "ReasonBeingLateForm"
    },
    LIST_COMPANY: {
        form2: "CompanyForm",
        toolbar: {
            kit: "baseWithImportAndManageManagers"
        },
        import: {
            ext: ["xlsx"],
            target: "company"
        }
    },
    LIST_COMPANY_BANKS: {
        form2: "CompanyBankForm"
    },
    FIN_OPERATION_DETAIL_TYPE: {
        form2: "NameNoteForm"
    },
    LIST_COMPANY_BANK_ACCOUNTS: {
        form2: "BankAccountForm"
    },
    LIST_CONTRACTS: {
        form2: "ContractForm"
    },
    LIST_DOCUMENTS: {
        form2: "DocumentForm",
        prepares: ["DocumentStatusColor"]
    },
    CRM_REQUEST_SOURCE: {
        form2: "NameNoteForm"
    },
    LIST_ADDRESS_COMPANY: {
        form2: "AddressForm"
    },
    LIST_COMPANY_CONTACT_PERSONS: {
        form2: "ContactFaceForm"
    },
    LIST_CONTACT_PERSONS: {
        form2: "ContactFaceForm"
    },
    LIST_TYPE_CONTRACTS: {
        form2: "ContractNameForm"
    },
    LIST_PERSON_POST: {
        form2: "ContactFacePostForm"
    },
    LIST_TYPE_DOCUMENT: {
        form2: "DocumentTypeForm"
    },
    LIST_BANKS: {
        form2: "BankForm"
    },
    LIST_AUTO: {
        form2: "CarForm"
    },
    LIST_TYPE_MODEL_AUTO: {
        form2: "CarModelForm"
    },
    LIST_CLASS_DANGER: {
        form2: "ClassDangerForm"
    },
    LIST_CURS: {
        form2: "CurrencyCursForm"
    },
    LIST_CURS_INTERNAL: {
        form2: "CurrencyCursForm"
    },
    LIST_DRIVERS: {
        form2: "DriverForm",
        prepares: ["driverRedTrust"]
    },
    LIST_TYPE_VAN: {
        form2: "VanForm"
    },
    LIST_NAME_WEIGHT: {
        form2: "WeightNameForm"
    },
    LIST_CLASSIFICATION: {
        form2: "ClassesListForm",
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["xlsx"],
            target: "classes"
        },
        plugins: [
            {
                name: "FileUploaded"
            }
        ]
    },
    CLASS_ACCESS_DOCS: {
        form2: "ClassAccessDocForm"
    },
    CLASS_ACCESS_DOCS_FROM_PART_NUMBER_POSITION: {
        form2: "ClassAccessDocForm"
    },
    CLASS_ACCESS_DOCS_TYPE: {
        form2: "ClassAccessDocTypeForm"
    },
    CLASS_ACCESS_DOCS_TYPE_COUNT_44: {
        form2: "NameNoteForm"
    },
    LIST_USER: {
        form2: "UserForm",
        clone: {
            function: "clone_user"
        }
    },
    LIST_HOOK: {
        form2: "HookForm"
    },
    LIST_TYPE_MODEL_HOOK: {
        form2: "HookModelForm"
    },
    LIST_WAREHOUSE: {
        form2: "PointForm"
    },
    LIST_ORDER_POSITIONS: {
        form2: "OrderPositionForm"
    },
    LIST_DELIVERY_CONDITIONS: {
        form2: "DeliveryConditionsForm"
    },
    LIST_COUNTRY: {
        form2: "CountryForm"
    },
    LIST_REGION: {
        form2: "RegionForm"
    },
    LIST_CITY: {
        form2: "CityForm"
    },
    LIST_AIRPORTS: {
        form2: "AirportForm"
    },
    LIST_NAVALPORTS: {
        form2: "NavalPortForm"
    },
    LIST_RAILWAYS: {
        form2: "RailwayForm"
    },
    GU_FORM_STATUS: {
        form2: "NameNoteForm"
    },
    LIST_INSPECTOR: {
        form2: "NameNoteForm"
    },
    LIST_GTD_GOODS: {
        form2: "GTDFeaccForm"
    },
    LIST_TNVED: {
        form2: "CodeNameForm"
    },
    LIST_GNG: {
        form2: "CodeNameForm"
    },
    LIST_ETSNG: {
        form2: "CodeNameForm"
    },
    GTD_FACT_TYPE: {
        form2: "NameNoteForm"
    },
    LIST_GTD: {
        form2: "GTDForm",
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["xml"],
            target: "gtd"
        }
    },
    LIST_ACTIVE_GTD: {
        form2: "GTDForm",
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["xml"],
            target: "gtd"
        }
    },
    LIST_ARCHIVE_GTD: {
        form2: "GTDForm",
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["xml"],
            target: "gtd"
        }
    },
    LIST_ALL_GTD: {
        form2: "GTDForm",
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["xml"],
            target: "gtd"
        }
    },
    LIST_FEACC_GTD: {
        form2: "GTDFeaccForm"
    },
    LIST_FEACC_DOCUMENTS: {},
    LIST_COMPANY_GROUPS: {
        form2: "NameNoteForm"
    },
    LIST_COMPANY_MARKS: {
        form2: "NameNoteForm"
    },
    LIST_COMPANY_LIFE_CYCLE: {
        form2: "NameNoteForm"
    },
    OPERATION_UNIT_TYPE: {
        form2: "OperationUnitTypeForm"
    },
    INVOICE_INCOMING: {
        form2: "InvoiceForm",
        plugins: [{ name: "DontRemoveMirrorIncomingInvoice" }],
        clone: {
            function: "clone_invoice_incoming"
        },
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["json"]
        },
        dataFields: [
            "ID_LIST_COMPANY_PAYER",
            "ID_LIST_COMPANY_CONTRACTOR",
            "ID_LIST_CURRENCY",
            "LIST_CURRENCY_CHARCODE",
            "NOTE",
            "SUM_WITH_VAT_IN_CURS",
            "RATE_EXPENSE_TYPE_NAMES"
        ]
    },
    INVOICE: {
        form2: "InvoiceForm",
        plugins: [
            { name: "DontRemoveMirrorIncomingInvoice" },
            { name: "SetIsPaymentDateByUser" }
        ],
        toolbar: {
            kit: "baseWithImport"
        },
        dataFields: [
            "ID_LIST_COMPANY_PAYER",
            "ID_LIST_COMPANY_CONTRACTOR",
            "ID_LIST_CURRENCY",
            "LIST_CURRENCY_CHARCODE",
            "NOTE",
            "SUM_WITH_VAT_IN_CURS",
            "RATE_EXPENSE_TYPE_NAMES"
        ]
    },
    INVOICE_OUTGOING_MONEY: {
        form2: "InvoiceForm",
        plugins: [
            { name: "DontRemoveMirrorIncomingInvoice" },
            { name: "SetIsPaymentDateByUser" }
        ],
        clone: {
            function: "clone_invoice_outgoing_money"
        },
        toolbar: {
            kit: "baseWithImport"
        },
        dataFields: [
            "ID_LIST_COMPANY_PAYER",
            "ID_LIST_COMPANY_CONTRACTOR",
            "ID_LIST_CURRENCY",
            "LIST_CURRENCY_CHARCODE",
            "NOTE",
            "SUM_WITH_VAT_IN_CURS",
            "RATE_EXPENSE_TYPE_NAMES"
        ]
    },
    INVOICE_INCOMING_MONEY: {
        form2: "InvoiceForm",
        plugins: [
            { name: "DontRemoveMirrorIncomingInvoice" },
            { name: "SetIsPaymentDateByUser" }
        ],
        clone: {
            function: "clone_invoice_incoming_money"
        },
        toolbar: {
            kit: "baseWithImport"
        },
        dataFields: [
            "ID_LIST_COMPANY_PAYER",
            "ID_LIST_COMPANY_CONTRACTOR",
            "ID_LIST_CURRENCY",
            "LIST_CURRENCY_CHARCODE",
            "NOTE",
            "SUM_WITH_VAT_IN_CURS",
            "RATE_EXPENSE_TYPE_NAMES"
        ]
    },
    INVOICE_OUTGOING: {
        form2: "InvoiceForm",
        plugins: ["SetIsPaymentDateByUser"],
        clone: {
            function: "clone_invoice_outgoing"
        },
        toolbar: {
            kit: "baseWithImport"
        },
        dataFields: [
            "ID_LIST_COMPANY_PAYER",
            "ID_LIST_COMPANY_CONTRACTOR",
            "ID_LIST_CURRENCY",
            "LIST_CURRENCY_CHARCODE",
            "NOTE",
            "SUM_WITH_VAT_IN_CURS",
            "RATE_EXPENSE_TYPE_NAMES"
        ]
    },
    INVOICE_POSITIONS: {
        clone: {
            function: "clone_invoice_positions"
        }
    },
    USER_TASK: {
        form2: "UserTaskForm",
        prepares: ["TaskColors"]
    },
    CONTRACTS_ADDITION_TYPE: {
        form2: "NameNoteForm"
    },
    CONTRACTS_ADDITION: {
        form2: "ContractsAdditionForm"
    },
    LIST_CUSTOMS_INSPECTORS: {
        form2: "CustomsInspectorForm"
    },
    PAYMENT_ORDERS: {
        form2: "PaymentOrderForm",
        clone: {
            function: "clone_payment_orders"
        },
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["txt"]
        },
        dataFields: [
            "ID_LIST_COMPANY_FROM",
            "ID_LIST_COMPANY_TO",
            "ID_LIST_CURRENCY",
            "LIST_CURRENCY_CHARCODE",
            "SUMM",
            "NOTE"
        ]
    },
    PAYMENT_ORDERS_INCOMING: {
        form2: "PaymentOrderForm",
        clone: {
            function: "clone_payment_orders"
        },
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["txt", "csv"]
        },
        dataFields: [
            "ID_LIST_COMPANY_FROM",
            "ID_LIST_COMPANY_TO",
            "ID_LIST_CURRENCY",
            "LIST_CURRENCY_CHARCODE",
            "SUMM",
            "NOTE"
        ]
    },
    PAYMENT_ORDERS_OUTGOING: {
        form2: "PaymentOrderForm",
        sub: {
            LIST_PAYMENTS_GTD_LINK: {
                link: {
                    ID_PAYMENT_ORDERS: "[row].id"
                },
                leftColumn: false,
                fields: [
                    "TYPE_PAYMENT_LINK",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "PAYMENTS_GTD_TYPE_NAME",
                    "SUM_PAYMENT",
                    "PAYMENT_WAY"
                ],
                bottom: false,
                toolbar: false,
                mode: "light"
            }
        },
        clone: {
            function: "clone_payment_orders"
        },
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["txt", "csv"]
        },
        dataFields: [
            "ID_LIST_COMPANY_FROM",
            "ID_LIST_COMPANY_TO",
            "ID_LIST_CURRENCY",
            "LIST_CURRENCY_CHARCODE",
            "SUMM",
            "NOTE"
        ]
    },
    PAYMENT_ORDERS_OUR_COMPANY: {
        form2: "PaymentOrderForm",
        toolbar: {
            kit: "baseWithAccountOperationsAndImport"
        },
        import: {
            ext: ["txt"]
        }
    },
    PAYMENT_ORDERS_EXPENCE_TYPE: {
        form2: "PaymentOrdersExpenceTypeForm",
        plugins: [
            {
                name: "InlineFilter",
                params: {
                    columns: [
                        {
                            name: "PAYMENT_ORDERS_SUBGROUP_EXPENCE_TYPE_NAME",
                            filterBy: {
                                fields: {
                                    ID_GROUP_EXPENCE_TYPE: "ID_GROUP_EXPENCE_TYPE"
                                }
                            }
                        }
                    ]
                }
            },
            {
                name: "AutoCompleteField",
                params: {
                    needToCheckTable: "PAYMENT_ORDERS_SUBGROUP_EXPENCE_TYPE",
                    needToAutoCompleteField: "ID_GROUP_EXPENCE_TYPE",
                    needToClearField: "ID_SUBGROUP_EXPENCE_TYPE"
                }
            }
        ]
    },
    TRANSFER_DISLOCATION: {
        form2: "TransferDislocationForm",
        toolbar: {
            kit: "baseWithImport"
        }
    },
    COMPANY_GTD_BALANCE: {
        form2: "CompanyBalanceGTDForm",
        UnderRow: {
            groups: [
                { columns: ["SUM_AVANS_OUT", "SUM_AVANS", "SUM_AVANS_DIFF"] },
                { columns: ["SUM_TAX_OUT", "SUM_TAX", "SUM_TAX_DIFF"] },
                { columns: ["SUM_OTHER_TAXES_OUT", "SUM_OTHER_TAXES", "SUM_OTHER_TAXES_DIFF"] },
                { columns: ["SUM_EXCISE_OUT", "SUM_EXCISE", "SUM_EXCISE_DIFF"] },
                { columns: ["SUM_PK_OUT", "SUM_PK", "SUM_PK_DIFF"] }
            ]
        }
    },
    GTD_MODE: {
        form2: "NameNoteForm"
    },
    DEPARTMENT: {
        form2: "DepartmentForm",
        sub: {
            DEPARTMENT_USER_LIST: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: ["FULL_NAME", "LIST_PERSON_POST_NAME", "PHONE1", "PHONE2"],
                link: {
                    ID_DEPARTMENT: "[row].ID"
                },
                plugins: [{ name: "DepartmentUserList" }]
            }
        }
    },
    VESSEL: {
        form2: "VesselForm"
    },
    REVALUE_TRANSFER: {
        form2: "RevalueTransferForm",
        leftColumn: false,
        toolbar: {
            kit: "readOnly"
        },
        access: {
            create: false,
            remove: false
        }
    },
    CONTRACTS_FEA: {
        form2: "ContractsFeaForm",
        clone: {
            function: "clone_contracts_fea"
        }
    },
    CONTRACTS_FEA_ADDITION: {
        form2: "ContractsFeaAdditionForm"
    },
    NOTIFICATIONS: {
        form2: "NotificationForm",
        prepares: ["GrayNotyIfNotReaded"],
        toolbar: {
            kit: "notifications"
        },
        dataFields: ["IS_READED"]
    },
    LIST_VAT: {
        form2: "VatForm"
    },
    REQUEST_CURRENCY_TRANSLATION: {
        form2: "RequestCurrencyTranslationForm",
        clone: {
            function: "clone_request_currency_translation"
        }
    },
    REQUEST_CURRENCY_TRANSLATION_TYPE: {
        form2: "NameNoteForm"
    },
    CONTRACTS_MATH_DETAILS: {
        form2: "NameNoteForm"
    },
    CONTRACTS_PAYMENT_TYPE: {
        form2: "NameNoteForm"
    },
    CONTRACTS_STATUS: {
        form2: "NameNoteForm"
    },
    CONTRACTS_RELATION_TYPE: {
        form2: "NameNoteForm"
    },
    COMPANY_CRM: {
        form2: "CompanyCRMForm",
        clone: {
            function: false
        },
        toolbar: {
            kit: "companyCrm"
        }
    },
    COMPANY_CRM_EVENT: {
        form2: "CompanyCRMEventForm"
    },
    PRODUCTION: {
        form2: "NameNoteForm"
    },
    COMPANY_CRM_STATUS: {
        form2: "NameNoteForm"
    },
    COMPANY_CRM_TYPE_REQUEST: {
        form2: "NameNoteForm"
    },
    COMPANY_CRM_EVENT_IMPORTANT: {
        form2: "NameNoteForm"
    },
    COMPANY_CRM_EVENT_TYPE: {
        form2: "NameNoteForm"
    },
    COMPANY_CRM_EVENT_CONNECTION_TYPE: {
        form2: "NameNoteForm"
    },
    ORDER_REQUEST: {
        form2: "OrderLogSchemeForm",
        clone: {
            function: "clone_order",
            reload: [
                "OPERATION_SEA",
                "OPERATION_TRAIN",
                "OPERATION_FORWARD",
                "OPERATION_CUSTOMS",
                "OPERATION_AUTO",
                "OPERATION_AIR",
                "OPERATION_DETAIL",
                "OPERATION_DOCUMENTATION",
                "OPERATION_REPACKING",
                "OPERATION_OTHER"
            ]
        }
    },
    ORDER_DOCS_SCHEME: {
        form2: "OrderDocSchemeForm",
        clone: {
            function: "clone_order",
            reload: ["DOC_OPERATION"]
        }
    },
    ORDER: {
        form2: "OrderForm",
        dataFields: ["IS_REQUEST", "IS_CURATOR_BY_CLIENT_OR_PARTNER", "IS_SALES_MANAGER_BY_CLIENT"],
        plugins: [
            "DefaultClientAndPartnerInOrder",
            {
                name: "DisableInlineEdit",
                params: [
                    {
                        modules: ["Stel", "Intrans"],
                        fields: ["MIN_DATE_GTD_CLEAR_EXPECTED"],
                        not: true // разблокирует для указанных модулей
                    }
                ]
            }
        ],
        clone: {
            function: "clone_order",
            reload: [
                "OPERATION_SEA",
                "OPERATION_TRAIN",
                "OPERATION_FORWARD",
                "OPERATION_CUSTOMS",
                "OPERATION_AUTO",
                "OPERATION_AIR",
                "OPERATION_DETAIL",
                "DOC_OPERATION",
                "OPERATION_DOCUMENTATION",
                "OPERATION_REPACKING",
                "OPERATION_OTHER"
            ]
        },
        import: {
            ext: ["csv"],
            target: "order"
        }
    },
    OPERATION: {
        form2: "OperationForm"
    },
    OPERATION_UNIT: {
        form2: "OperationUnitForm",
        toolbar: {
            kit: "operationUnit"
        },
        plugins: [
            {
                name: "DisableInlineEdit",
                params: [
                    {
                        modules: ["Canavara"],
                        fields: ["UNIT_NUMBER"]
                    }
                ]
            }
        ],
        prepare: ["TimexColorDateReleaseTo", "TransLogixColorDateReleaseTo", "ColorizeDriverCellInUnit"]
    },
    OPERATION_RATE_EXPENSE_TYPE: {
        form2: "OperationRateExpenseTypeForm"
    },
    OPERATION_FORWARD: {
        form2: "OperationForm"
    },
    OPERATION_SEA: {
        form2: "OperationForm"
    },
    OPERATION_TRAIN: {
        form2: "OperationForm"
    },
    OPERATION_CUSTOMS: {
        form2: "OperationForm"
    },
    OPERATION_REPACKING: {
        form2: "OperationForm"
    },
    OPERATION_DOCUMENTATION: {
        form2: "OperationForm"
    },
    OPERATION_OTHER: {
        form2: "OperationForm"
    },
    OPERATION_AUTO: {
        form2: "OperationForm"
    },
    OPERATION_AIR: {
        form2: "OperationForm"
    },
    OPERATION_PACKING_UNIT_TYPE: {
        form2: "OperationPackingUnitTypeForm"
    },
    OPERATION_UNIT_DIVISION: {
        form2: "NameNoteForm"
    },
    OPERATION_DETAIL: {
        form2: "OperationDetailForm"
    },
    OPERATION_FORWARD_INSPECTION: {
        form2: "OperationForwardInspectionForm"
    },
    OPERATION_FORWARD_INSPECTION_TYPE: {
        form2: "NameNoteForm"
    },
    OPERATION_SUB_DOC: {
        form2: "OperationSubDocForm"
    },
    OPERATION_CUSTOM_STATUS_TYPE: {
        form2: "NameNoteForm"
    },
    OPERATION_CUSTOM_STATUS: {
        form2: "OperationCustomStatusForm"
    },
    DOC_OPERATION: {
        form2: "DocOperationForm"
    },
    DOC_OPERATION_UNIT_LINK: {
        form2: "DocOperationForm"
    },
    DOC_OPERATION_TYPE: {
        form2: "NameNoteForm"
    },
    FIN_OPERATION_TYPE: {
        form2: "NameNoteForm"
    },
    FIN_OPERATION: {
        form2: "FinOperationForm"
    },
    ORDER_REQUEST_CONTRACT_TYPE: {
        form2: "NameNoteForm"
    },
    DOCUMENT_MANAGEMENT: {
        form2: "DocumentManagementForm",
        sub: {
            DOCUMENT_MANAGEMENT_DOCS: {
                fields: [
                    "DOCUMENT_MANAGEMENT_TYPE_NAME",
                    "NUMBER",
                    "MANAGEMENT_DATE",
                    "ORIG_QUANTITY",
                    "COPY_QUANTITY",
                    "ORIG_COPY_QUANTITY",
                    "VERIFIED_COPY_QUANTITY",
                    "NOTARIZED_COPY_QUANTITY",
                    "NOTARIZED_ORIG_QUANTITY",
                    "IS_RELEASE",
                    "IS_ADDITION1",
                    "IS_ADDITION2",
                    "HAS_DTS",
                    "HAS_KTS",
                    "NOTE"
                ],
                fieldsProp: {},
                edit: {
                    mode: "inline"
                },
                link: {
                    ID_DOCUMENT_MANAGEMENT: "[row].ID"
                },
                bottom: false,
                toolbar: false,
                mode: "light"
            }
        }
    },
    DOCUMENT_MANAGEMENT_DOC_TYPE: {
        form2: "DocumentManagementDocTypeForm"
    },
    COURIER: {
        form2: "CourierForm"
    },
    LIST_POST_CUSTOMS_GTD: {
        form2: "GTDForm",
        prepares: ["GtdColorsByAdditionalCheckDate"]
    },
    WORK_INSTRUCTIONS_DOCUMENT: {
        form2: "WorkInstructionDocumentForm"
    },
    WORK_INSTRUCTIONS_TYPE: {
        form2: "NameNoteForm"
    },
    WORK_INSTRUCTIONS_STATUS: {
        form2: "NameNoteForm"
    },
    WORK_INSTRUCTIONS_CATEGORY: {
        form2: "WorkInstructionCategoryForm",
        sub: {
            WORK_INSTRUCTIONS_DOCUMENT: {
                form2: "WorkInstructionDocumentForm",
                useFullRights: true,
                link: {
                    ID_WORK_INSTRUCTIONS_CATEGORY: "[row].id"
                },
                fields: ["FILE_NAME", "LIST_DOCUMENTS_NAME", "NOTE", "INSTRUCTION_STATUS_NAME"],
                fieldsProp: {
                    FILE_NAME: 0.2,
                    NOTE: 0.35,
                    LIST_DOCUMENTS_NAME: 0.45,
                    INSTRUCTION_STATUS_NAME: 0.55
                },
                bottom: false,
                toolbar: false,
                mode: "light"
            }
        }
    },
    SYS_ACL_ROLE: {
        form2: "RoleForm",
        formPath: "classes/system/rights/form/RoleForm",
        clone: {
            function: "clone_sys_acl_role"
        }
    },
    USER_TASK_THEME: {
        form2: "UserTaskThemeForm"
    },
    USER_TASK_THEME_TO_BUS_OP: {
        form2: "UserTaskThemeToBusOpForm"
    },
    FIN_OPERATION_GROUP_UNIT: {
        form2: "FinOperationGroupUnitForm"
    },
    ADDITIONAL_CONTROL_TYPE: {
        form2: "NameNoteForm"
    },
    SIZE: {
        form2: "NameNoteForm"
    },
    AGE_TYPE: {
        form2: "NameNoteForm"
    },
    PRODUCT_TYPE: {
        form2: "NameNoteForm"
    },
    PRODUCT_CATEGORY: {
        form2: "NameNoteForm"
    },
    MATERIAL: {
        form2: "NameNoteForm"
    },
    COLOR: {
        form2: "NameNoteForm"
    },
    OPERATION_TYPE: {
        form2: "OperationTypeForm"
    },
    PART_NUMBER: {
        form2: "PartNumberForm",
        toolbar: {
            kit: "baseWithImport"
        },
        import: {
            ext: ["xlsx"],
            target: "part_number"
        }
    },
    WEIGHT_GROUP: {
        form2: "NameNoteForm"
    },
    OWN_ROLLING_STOCK_UNIT: {
        form2: "OwnRollingStockUnitForm"
    },
    OWNER_UNIT: {
        form2: "OwnerUnitForm"
    },
    ORDER_FOR_OWNER_UNIT: {
        form2: "OrderForm"
    },
    ORDER_FOR_OWN_ROLLING_STOCK_UNIT: {
        form2: "OrderForm"
    },
    OPERATION_RATE_EXPENSE_INCLUDE: {
        form2: "OperationRateExpenseIncludeForm"
    },
    OPERATION_CARGO_STATUS_EX_T1: {
        form2: "NameNoteForm"
    },
    COMPANY_DOC_NUMBER_MASK: {
        form2: "CompanyDocNumberMaskForm"
    },
    LIST_PAYMENTS_GTD_LINK: {},
    BUSINESS_PROCESS: {
        form2: "BusinessProcessForm",
        clone: {
            function: "clone_business_process",
            reload: ["BUSINESS_OPERATION"]
        }
    },
    BUSINESS_OPERATION: {
        form2: "BusinessOperationForm"
    },
    LIST_FEACC_ARTICLE: {
        form2: "GTDFeaccForm"
    },
    PART_NUMBER_POSITION: {
        form2: "PartNumberPositionForm"
    },
    OPERATION_RATE_EXPENSE_CATEGORY: {
        form2: "OperationRateExpenseCategoryForm"
    },
    NOMENCLATURE_TO_PRINT: {
        form2: "NomenclatureToPrintForm"
    },
    REQUEST_GTD: {
        form2: "RequestGtdForm"
    },
    CRM_REQUEST_STATUS: {
        form2: "NameNoteForm"
    },
    LIST_CONTACT_PERSONS_EMAIL_BROADCAST_CONFIG: {
        form2: "ContactFaceDocEmailForm"
    },
    TEMPLATE_INVOICE_POST: {
        form2: "TemplateInvoicePostForm"
    },
    TEMPLATE_INVOICE: {
        form2: "TemplateInvoiceForm"
    },
    ORDER_NOTIFICATIONS: {
        form2: "OrderNotificationForm"
    },
    LIST_GTD_NOTIFICATIONS: {
        form2: "GtdNotificationForm"
    },
    SEA_RATES: {
        form2: "SeaRatesForm",
        clone: {
            function: "clone_sea_rates"
        }
    },
    AUTO_RATES: {
        form2: "AutoRatesForm",
        clone: {
            function: "clone_auto_rates"
        }
    },
    SEA_PORT_EXPENSES: {
        form2: "SeaPortExpensesForm",
        clone: {
            function: "clone_sea_port_expenses"
        }
    },
    STORAGE_RATES: {
        form2: "StorageRatesForm",
        clone: {
            function: "clone_company_storage_rates",
            link: "ID_COMPANY_STORAGE_RATES",
            reload: ["COMPANY_STORAGE_RATES"]
        }
    },
    COMPANY_STORAGE_RATES: {
        form2: "CompanyStorageRatesForm"
    },
    GTD_RESULT_RETURNING_OTP_STATUS: {
        form2: "NameNoteForm"
    },
    GTD_ADDITIONAL_CHECK_STATUS: {
        form2: "NameNoteForm"
    },
    MANUFACTURER: {
        form2: "ManufacturerForm"
    },
    CONTRACTS_FEA_ADDITION_SPECIFICATIONS: {
        form2: "AdditionSpecificationsForm"
    },
    LIST_REUSABLE_CONTAINERS: {
        form2: "ReusableContainerForm"
    },
    LIST_REUSABLE_CONTAINERS_POSITION: {
        form2: "ReusableContainerPosForm"
    },
    LIST_REUSABLE: {
        form2: "ListReusableForm"
    },
    FEEDBACK_TYPE: {
        form2: "NameNoteForm"
    },
    PERSON_TO_NOTIFY: {
        form2: "NameNoteForm"
    },
    SUPERMARKET_TYPE: {
        form2: "SupermarketForm"
    },
    DOCUMENT_STATUS: {
        form2: "NameNoteForm"
    },
    TRAIN: {
        form2: "TrainForm"
    },
    CRITERIA_TYPE: {
        form2: "CriteriaTypeForm"
    },
    CRITERIA_VALUE: {
        form2: "CriteriaValueForm"
    },
    ROLIS_EVENT: {},
    ROLIS_SUBSCRIPTION: {},
    ROLIS_EDI: {},
    EFFEX_EVENTS_UNIT: {},
    PAYMENT_ORDERS_GROUP_EXPENCE_TYPE: {
        form2: "NameNoteForm"
    },
    PAYMENT_ORDERS_SUBGROUP_EXPENCE_TYPE: {
        form2: "PaymentOrdersSubgroupExpenceTypeForm"
    },
    DOCS_SEND_METHOD: {
        form2: "NameNoteForm"
    },
    FIN_SETTINGS: {
        form2: "FinanceSettingsForm"
    },
    BATCH_FIN_OPERATION: {
        form2: "BatchFinOperationForm"
    },
    CUSTOM_CURRENCY_CURS: {
        form2: "OrderSetCursForm"
    },
    LIST_COMPANY_CATEGORY_GROUP: {
        form2: "ListCompanyCategoryGroupForm"
    },
    LIST_COMPANY_CATEGORY: {
        form2: "ListCompanyCategoryForm"
    },
    PRODUCT: {
        form2: "NameNoteForm"
    },
    MOVE_TYPE: {
        form2: "NameNoteForm"
    },
    BIZ_SCOPE: {
        form2: "NameNoteForm"
    },
    BL_TYPE: {
        form2: "NameNoteForm"
    },
    DIVISION: {
        form2: "NameNoteForm"
    },
    TEMPLATE_NOTIFICATION_MAILING: {
        form2: "TemplateNotificationMailingForm"
    },
    TEMPLATE_NOTIFICATION_MAILING_DOC: {
        form2: "TemplateNotificationMailingDocForm"
    },
    DYNAMIC_JOURNALS: {
        form2: "ConfigDynamicJournalForm"
    },
    REPORT_SETTINGS: {
        form2: "ReportSettingsForm"
    },
    REPORT_OUR_COMPANY: {
    },
    ICB_OFFICE: {
        form2: "IcbOfficeForm"
    },
    PAYABLE_CSO: {
        form2: "PayableCsoForm"
    },
    FIN_OPERATION_ORDER_DOC_LINK: {
        form2: "FinOperationForm"
    },
    FIN_OPERATION_COMMERCIAL_OFFER: {
        form2: "FinOperationForm"
    },
    MANAGER_BONUS: {
        form2: "ManagerBonusForm"
    },
    ALTA_CBX_DATA: {
        form2: "AltaCbxDataForm"
    },
    OPERATION_COMBINER: {
        form2: "OperationForm"
    },
    COMPANY_ADDITIONAL_INFORMATION: {
        form2: "CompanyAdditionalInformationForm"
    },
    PAYMENT_DAY_OF_THE_WEEK: {},
    INDUSTRY: {
        form2: "IndustryForm"
    },
    RISK_CLASS: {
        form2: "RiskClassForm"
    },
    CFO: {
        form2: "CFOForm"
    },
    BRUNCH: {
        form2: "BRUNCHForm"
    },
    LIST_OWNERSHIP_TYPE: {
        form2: "ListOwnershipTypeForm"
    },
    TEMPLATE_PAYMENT_SCHEDULE: {
        form2: "TemplatePaymentScheduleForm"
    },
    SERVICE_COMBINATION: {
        form2: "ServiceCombinationForm"
    },
    GHQ_ACTIVITY: {
        form2: "GhqActivityForm"
    },
    PRELIMINARY_GTD_STATUS: {
        form2: "PreliminaryGtdStatusForm"
    },
    PAYMENT_SCHEDULE: {
        form2: "PaymentScheduleForm"
    },
    CONSOL_TYPE: {
        form2: "ConsolTypeForm"
    },
    CARGO_CONDITION: {
        form2: "CargoConditionForm"
    },
    DEVIATION_REASON: {
        form2: "DeviationReasonForm"
    },
    BRANCH_YUNAS: {
        form2: "BranchYunasForm"
    },
    REJECTED_BY: {
        form2: "RejectedByForm"
    },
    SAMPLE_COLLECTION: {
        form2: "SampleCollectionForm"
    },
    WHT: {
        form2: "WhtForm"
    },
    COMPANY_SUBDIVISION: {
        form2: "NameNoteForm"
    }
};
